/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { ErrorHttpContentDto, GetInternationalOptionValuesResponseDto } from "../";
import { HttpClient, RequestParams } from "./http-client";

@Injectable()
export class InternationalAchOptionsClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags InternationalAchOptions
   * @name InternationalAchOptionsGet
   * @summary Gets the international option values.
   * @request GET:/internationalAchOptions
   */
  internationalAchOptionsGet = (params: RequestParams = {}) =>
    this.http.request<GetInternationalOptionValuesResponseDto, ErrorHttpContentDto>({
      path: `/internationalAchOptions`,
      method: "GET",
      format: "json",
      ...params,
    });
}
